import { Injectable } from '@angular/core';
import * as Routes from 'src/Routes';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class MecanicienService {

  constructor(private http: HttpClient) { }


  post(formData: FormData): Promise<any> {
    return this.http.post<any>(Routes.MECANICIEN, formData).toPromise();
  }

  update(formData: FormData, id): Promise<any> {
    return this.http.post<any>(`${Routes.MECANICIEN}/${id}`, formData).toPromise();
  }

  delete(id: number) {
    return this.http.delete(`${Routes.MECANICIEN}/${id}`).toPromise();

  }

  find(id: number): Promise<any> {
    return this.http.get<any>(`${Routes.MECANICIEN}/${id}`).toPromise();
  }
  public gets(page) {
    return this.http.get<any>(`${Routes.MECANICIEN}?page=${page}`)
      .toPromise();
  }

  public get(url) {
    return this.http.get<any>(`${url}`)
      .toPromise();
  }

  public getFormation() {
    return this.http.get<any>(`${Routes.FORMATION}`)
      .toPromise();
  }

  public getUser() {
    return this.http.get<any>(`${Routes.USER}`)
      .toPromise();
  }
}
